module.exports = __webpack_public_path__ + "static/img/phone2.87b0a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone2.png
// module id = 3zUX
// module chunks = 1